export const ORDER_STATUS_PENDING = "pending";
export const ORDER_STATUS_SHIPPED = "shipped";
export const ORDER_STATUS_COMPLETED = "completed";

export const PAYMENT_TYPES = {
  purchase_digital: "purchase_digital",
  purchase_physical: "purchase_physical",
  monthly_contribution: "monthly_contribution",
  contribution: "contribution",
};

export const USER_ROLES = {
  creator: "creator",
  customer: "customer",
  admin: "admin",
};

// Auth & Onboarding
export const LATEST_ONBOARDING_VERSION = 0; // Increment when requiring users to see new onboarding
export const GET_APP_BANNER_VERSION = 2;
// Error messages
export const AUTH_ERRORS = {
  INVALID_SESSION: 'Invalid session data received',
  AUTH_FAILED: 'Authentication failed. Please try again.',
  MISSING_CREDENTIALS: 'Missing email or password',
};

// Fee & Payment Constants
export const HYK_FEE_PERCENT = 0.1; // 10% HYK platform fee
export const STRIPE_FEE_PERCENT = 0.015; // 1.5% Stripe fee
export const STRIPE_FIXED_FEE = 0.25; // €0.25 Stripe fixed fee
export const VAT_PERCENT = 0; // 0% VAT (no tax)
export const HYK_FEE_PERCENT_WITHDRAWAL = 0; // 0% HYK platform fee